module.exports = __webpack_public_path__ + "static/media/availability_comparative_per_subpark.b66a4a20.svg";